// src/components/SEO/SEO.jsx
import React from "react";
import {Helmet} from "react-helmet-async";

const SEO = ({title, description, keywords, image, url}) => {
  return (
    <Helmet>
      <title>{title}</title>

      {/* Basic meta */}
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />

      {/* Twitter */}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
};

export default SEO;
